import { BookButton } from './book-button';
import { useWebScheduler } from './web-scheduler-provider';

interface WebSchedulerWidgetProps {
    compact?: boolean;
}

export const WebSchedulerWidget = ({ compact }: WebSchedulerWidgetProps) => {
    const { webSchedulerScriptLoadedSuccessfully } = useWebScheduler();
    const handleClick = () => {
        window.STWidgetManager('ws-open');
    };

    return (
        webSchedulerScriptLoadedSuccessfully && (
            <BookButton onClick={handleClick} compact={compact} />
        )
    );
};
